import styles from './VServicesModalCleaningDetails.module.css'

// Modal
import { useModalWindow } from "react-modal-global";
import useScrollBlock from "../../../../../../customHooks/useScrollBlock";
import PopupAppearLayout from "../../../../common/Modals/Layouts/PopupAppearLayout";
// 
import image from './image.jpg'

const VServicesModalCleaningDetails = () => {

    const modal = useModalWindow();
    const [blockScroll, allowScroll] = useScrollBlock();
    const closeModal = () => {
      // setTimeout(function(){allowScroll()}, 150);
      allowScroll()
      modal.close()
    } 
    
    return (
        <PopupAppearLayout classNameLayout={styles.popup__layout}>
            <div className={styles.container}>

                
                {/* HEADER */}
                <div className={styles.header_container}>
                    <div className={styles.header_title}>
                        <p>Санитарная обработка и промывка аппаратов</p>
                    </div>
                    
                    <button
                        className={styles.popup_layout__close}
                        type="button"
                        onClick={closeModal}
                        aria-label="Закрыть"
                    >
                        &#9587;
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className={styles.content__container}>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Описание услуги
                        </div>
                        <div className={styles.text}>
                            Санитарная обработка и промывка аппаратов проводится специалистом и с использованием специальных средств для промывки пищевого оборудования. Аппарат принимается на промывку очищенным от пыли, грязи и с отсутствием воды в системе. Процедура занимает полный рабочий день.
                        </div>
                    </div>
                    {/* row */}
                    <div className={styles.row}>
                        <div className={styles.title}>
                            Когда необходима санитарная обработка
                        </div>
                        <div className={styles.text}>
                            <ul>
                                <li>Плановая санитарная обработка должна проводиться не реже 1 раза в 6-12 месяцев</li>
                                <li>После ремонта аппарата</li>
                                <li>Если налицо факт биообрастания, «позеленения» бутыли на аппарате вследствие использования родниковой и др. несертифицированной воды</li>
                                <li>В случае застоя воды в системе вследствие малого потребления воды, оставления воды в системе на продолжительное время Вашего отсутствия</li>
                                <li>При нарушении других правил пользования аппаратом (прикосновение к кранам грязными руками, засорение аппарата посторонними предметами, не удаление с крышки бутыли гигиенического стикера, попадание внутрь посторонних жидкостей, мыльных и едких моющих средств, использование аппарата в запыленных и грязных помещениях и на улице, установка аппарата с бутылью в местах попадания прямых солнечных лучей)</li>
                            </ul>
                        </div>
                    </div>
                    
                    <div className={styles.imageBlock}>
                        <img className={styles.image} src={image} alt="Санитарная обработка аппаратов" />
                    </div>

                    {/* buttons */}
                    <div className={styles.btnBlock}>
                        <button
                            className={styles.btn_return}
                            type="button"
                            onClick={closeModal}
                        >
                            Закрыть
                        </button>
                    </div>
                </div>

            </div>
        </PopupAppearLayout>
    );   
}

export default VServicesModalCleaningDetails;